import propTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openModal } from '../../reducers/modal'

class RemoveRelated extends Component {
  static propTypes = {
    itemId: propTypes.oneOfType([propTypes.string, propTypes.number]),
    openModal: propTypes.func
  }

  handleClick = evt => {
    const config = {
      title: 'Are you sure?',
      subtitle: 'Please click the button below to confirm removal',
      type: 'deleteRelated',
      args: { ...this.props }
    }
    this.props.openModal(config)
    evt.target.blur()
  }

  render() {
    return (
      <button className="btn-link" onClick={this.handleClick}>
        remove
      </button>
    )
  }
}

RemoveRelated.displayName = 'RemoveRelated'

export default connect(null, {
  openModal
})(RemoveRelated)
